<template>
  <section class="terms-content column col">
    <div
      v-if="!isKnownTermsVersion(version)"
      class="terms-content-message q-pa-xl"
      role="alert"
      aria-live="polite"
    >
      <lucide-icon
        name="search-x"
        size="48px"
        color="brand-dark"
        :stroke-width="1.75"
        class="q-mb-md"
        aria-hidden="true"
      />
      <h2 class="text-18 text-font-semibold line-height-md">Terms not found</h2>
      <p class="q-mt-xs text-14 text-secondary line-height-md">
        This version may not exist or is no longer available.
      </p>
    </div>

    <!-- sanitizeTermsHtml() runs DOMPurify; v-html is never raw HTML -->
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-else
      class="terms-content-body bg-accent-light text-14 line-height-lg"
      v-html="sanitizeTermsHtml(getTermsHtml(version))"
    />
    <!-- eslint-enable vue/no-v-html -->
  </section>
</template>

<script setup>
  import { isKnownTermsVersion, getTermsHtml } from 'src/assets/content/terms/index'
  import { sanitizeTermsHtml } from 'src/services/helpers/security.helper'

  defineProps({
    version: {
      type: String,
      required: true,
    },
  })
</script>

<style lang="scss">
  .terms-content {
    .terms-content-message {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    .terms-content-body {
      overflow-y: auto;
      padding: 1.5rem;
      border: 1px solid $border;
      border-radius: $input-border-radius;

      h1 {
        font-size: 1.375rem;
        margin-bottom: 0.75rem;
      }

      h2 {
        font-size: 1rem;
        margin-top: 1.5rem;
        margin-bottom: 0.5rem;
      }

      p {
        margin-bottom: 0.75rem;
      }

      ul {
        padding-left: 1.25rem;
        margin-bottom: 1rem;

        li {
          margin-bottom: 0.5rem;
        }

        ul {
          margin-top: 0.5rem;
          margin-bottom: 0.5rem;
        }
      }

      hr {
        border: none;
        border-top: 1px solid $border;
        margin: 1.5rem 0;
      }

      a {
        color: $brand;
        text-decoration: underline;

        &:hover {
          color: $brand-dark;
        }
      }

      strong {
        font-weight: 600;
      }
    }
  }
</style>
